const EmploymentChart = ({locationStatistics}) => {
    return (
        <>
            <h4 className="p-knowledge_title">Basic Information on Work in {locationStatistics.locationWord}</h4>
            {/* chart : Employment */}

            <div className="p-knowledge_content u-dip_flex">

                <div className="p-knowledge_text_wrap">
                    <p className="p-knowledge_text">{locationStatistics.employmentDescription}</p>
                    {locationStatistics.isDisplayableSalaryDescription &&
                        <p className="p-knowledge_text">{locationStatistics.salaryDescription}</p>
                    }
                </div>

                <div className="p-chart_wrap_flex">
                    <div className="p-chart_wrap">
                        <div className="p-chart_value_upper">
                            <p className="p-chart_value"><span
                                className="p-chart_value_data">{locationStatistics.employmentGraphDisplay}</span><span
                                className="p-chart_value_unit">{locationStatistics.employmentGraphDisplayUnit}</span>
                            </p>
                            <p className="p-chart_value_index">People Employed<span
                                className="p-chart_value_date">in {locationStatistics.newestStatisticsYearMonth}</span>
                            </p>
                        </div>
                        <div className="p-chart_line_wrap">
                            <canvas id="chartjs_employed"
                                    className="p-chart_line s-chart_line s-chart_line--employed"
                                    height="100"
                                    data-chart="employed"></canvas>
                            <ul className="p-chart_label">
                                <li className="p-chart_label_item">{locationStatistics.twoYearsAgoStatisticsYearMonth}</li>
                                <li className="p-chart_label_item">{locationStatistics.newestStatisticsYearMonth}</li>
                            </ul>
                        </div>
                        <div className="p-chart_value_bottom">
                            <div className="p-chart_value_bottom_item">
                                <p className="p-chart_value"><span
                                    className="p-chart_value_data">{locationStatistics.employmentTwoYearAverageGraphDisplay}</span><span
                                    className="p-chart_value_unit">{locationStatistics.employmentTwoYearAverageGraphDisplayUnit}</span>
                                </p>
                                <p className="p-chart_value_index">2 Year Average</p>
                            </div>
                            <div className="p-chart_value_bottom_item">
                                <p className="p-chart_value">
                                    {locationStatistics.isEmploymentHigherThanLastYear &&
                                        <span
                                            className="p-chart_value_status p-chart_value_status--up"></span>
                                    }
                                    {locationStatistics.isEmploymentLowerThanLastYear &&
                                        <span
                                            className="p-chart_value_status p-chart_value_status--down"></span>
                                    }
                                    {!locationStatistics.isEmploymentHigherThanLastYear && !locationStatistics.isEmploymentLowerThanLastYear &&
                                        <span
                                            className="p-chart_value_status p-chart_value_status--equivalent"></span>
                                    }
                                    <span
                                        className="p-chart_value_data">{locationStatistics.employmentLastYearDiffGraphDisplay}</span><span
                                    className="p-chart_value_unit">{locationStatistics.employmentLastYearDiffGraphDisplayUnit}</span>
                                </p>
                                <p className="p-chart_value_index">Year-on-Year</p>
                            </div>
                        </div>
                    </div>
                    {/* / chart : Employment */}

                    {/* chart : Unemployment Rate */}
                    <div className="p-chart_wrap">
                        <div className="p-chart_value_upper">
                            <p className="p-chart_value"><span
                                className="p-chart_value_data">{locationStatistics.unemploymentRateDisplay}</span><span
                                className="p-chart_value_unit">%</span>
                            </p>
                            <p className="p-chart_value_index">Unemployment Rate<span
                                className="p-chart_value_date">in {locationStatistics.newestStatisticsYearMonth}</span>
                            </p>
                        </div>
                        <div className="p-chart_line_wrap">
                            <canvas id="chartjs_unemployment"
                                    className="p-chart_line s-chart_line s-chart_line--unemployment"
                                    height="100" data-chart="unemployment"></canvas>
                            <ul className="p-chart_label">
                                <li className="p-chart_label_item">{locationStatistics.twoYearsAgoStatisticsYearMonth}</li>
                                <li className="p-chart_label_item">{locationStatistics.newestStatisticsYearMonth}</li>
                            </ul>
                        </div>
                        <div className="p-chart_value_bottom">
                            <div className="p-chart_value_bottom_item">
                                <p className="p-chart_value"><span
                                    className="p-chart_value_data">{locationStatistics.unemploymentRateTwoYearAverageDisplay}</span><span
                                    className="p-chart_value_unit">%</span></p>
                                <p className="p-chart_value_index">2 Year Average</p>
                            </div>
                            <div className="p-chart_value_bottom_item">
                                <p className="p-chart_value">
                                    {locationStatistics.isUnemploymentRateHigherThanLastYear &&
                                        <span
                                            className="p-chart_value_status p-chart_value_status--up"></span>
                                    }
                                    {locationStatistics.isUnemploymentRateLowerThanLastYear &&
                                        <span
                                            className="p-chart_value_status p-chart_value_status--down"></span>
                                    }
                                    {!locationStatistics.isUnemploymentRateHigherThanLastYear && !locationStatistics.isUnemploymentRateLowerThanLastYear &&
                                        <span
                                            className="p-chart_value_status p-chart_value_status--equivalent"></span>
                                    }
                                    <span
                                        className="p-chart_value_data">{locationStatistics.unemploymentRateLastYearDiffDisplay}</span><span
                                    className="p-chart_value_unit">%</span>
                                </p>
                                <p className="p-chart_value_index">Year-on-Year</p>
                            </div>
                        </div>
                    </div>
                    {/* / chart : Unemployment Rate */}
                </div>
            </div>
        </>
    )
}

export default EmploymentChart;
